/**
 * Konfiguration for forside-kampagnen (fuldskærms tilmeldings-takeover).
 * Kill switch: sæt `enabled: false` for at stoppe kampagnen før slutdatoen.
 */
export const HOME_CAMPAIGN = {
  enabled: true,
  /** Kampagnen vises ikke før dette tidspunkt. */
  start: '2026-09-03T00:00:00+02:00',
  /** Kampagnen forsvinder automatisk efter dette tidspunkt. */
  end: '2026-09-10T23:59:00+02:00',
  /** Nøgle i localStorage – bumpes hvis kampagnen skal vises igen. */
  storageKey: 'mnel.home-campaign.seen-v2',
  /** Bruges som placement i UTM-parametre og sporing. */
  placement: 'home-campaign',
} as const;

/** Er kampagnen aktiv lige nu (dato + kill switch)? */
export function isHomeCampaignWindowOpen(now: Date = new Date()): boolean {
  if (!HOME_CAMPAIGN.enabled) return false;
  const start = new Date(HOME_CAMPAIGN.start).getTime();
  const end = new Date(HOME_CAMPAIGN.end).getTime();
  const t = now.getTime();
  return t >= start && t <= end;
}

/** Har denne browser allerede set kampagnen? */
export function hasSeenHomeCampaign(): boolean {
  try {
    return localStorage.getItem(HOME_CAMPAIGN.storageKey) === '1';
  } catch {
    // Uden localStorage viser vi den ikke – bedre end at vise den ved hvert besøg.
    return true;
  }
}

export function markHomeCampaignSeen(): void {
  try {
    localStorage.setItem(HOME_CAMPAIGN.storageKey, '1');
  } catch {
    /* noop */
  }
}
